import { PMSmallTable } from "@pimo/pimo-components/src/lib/pm-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { theme } from "../../../theme";
import { formatDate } from "../../../utils/format-date";
import { DashboardCardContext } from "../context";

export function addDurationCard(ctx: DashboardCardContext) {
  const { view, language, projectName } = ctx;

  const durationComponent = view.addComponent({
    component: PMSmallTable,
    layoutProps: {
      componentId: "projectDurationComponent",
      title: "",
      description: "",
      labels: ["team"],
    },
  });

  durationComponent.mapLayoutProps(({ language }) => ({
    componentId: "projectDurationComponent",
    labels: ["team"],
    title: getLocalizedMessage(language, "projectDuration", {
      project: projectName,
    }),
    description: getLocalizedMessage(language || "en", "showsProjectDuration", {
      project: projectName,
    }),
  }));

  durationComponent.mapState(({ settings }) => {
    const startDate =
      settings?.configuration?.reportingCycle?.startReportingDate;
    const endDate = settings?.configuration?.reportingCycle?.endReportingDate;

    return {
      title: getLocalizedMessage(language, "programDuration"),
      icon: "InfoOutlined",
      items: [
        {
          label: getLocalizedMessage(language, "start"),
          value: formatDate(startDate),
          chipColor: theme.palette.secondary.main,
          chipTextColor: theme.palette.primary.main,
        },
        {
          label: getLocalizedMessage(language, "end"),
          value: formatDate(endDate),
          chipColor: theme.palette.secondary.light,
          chipTextColor: theme.palette.primary.main,
        },
      ],
    };
  });
}
